import { graphQlClient } from '@config/graphqlClient';
import { mutations, queries } from '@graphql/platformStatus.queries';
import {
  PlatformComponentKey,
  PlatformComponentState,
  PlatformStatusDetail,
  PlatformStatusSeverity,
} from '@models/platformStatus.model';

export interface SetOverridePayload {
  componentKey: PlatformComponentKey;
  state: PlatformComponentState;
  publicMessage?: string;
  internalNote?: string;
  expiresAt?: string;
}

export interface PublishMessagePayload {
  title: string;
  body: string;
  severity: PlatformStatusSeverity;
}

const getPlatformStatusDetail = async (): Promise<PlatformStatusDetail> => {
  const response = await graphQlClient.request<{
    platformStatusDetail: PlatformStatusDetail;
  }>(queries.GET_PLATFORM_STATUS_DETAIL);
  return response.platformStatusDetail;
};

const setOverride = async (input: SetOverridePayload): Promise<void> => {
  await graphQlClient.request(mutations.SET_PLATFORM_STATUS_OVERRIDE, {
    input,
  });
};

const clearOverride = async (
  componentKey: PlatformComponentKey,
): Promise<void> => {
  await graphQlClient.request(mutations.CLEAR_PLATFORM_STATUS_OVERRIDE, {
    componentKey,
  });
};

const publishMessage = async (input: PublishMessagePayload): Promise<void> => {
  await graphQlClient.request(mutations.PUBLISH_PLATFORM_STATUS_MESSAGE, {
    input,
  });
};

const clearMessage = async (): Promise<void> => {
  await graphQlClient.request(mutations.CLEAR_PLATFORM_STATUS_MESSAGE);
};

export const platformStatusService = {
  getPlatformStatusDetail,
  setOverride,
  clearOverride,
  publishMessage,
  clearMessage,
};
